/* eslint-disable import/no-cycle */
import React from "react"
import PropTypes from "prop-types"
import withRecursiveLayout from "../withRecursiveLayout"
import WidgetElement from "../WidgetElement"

/*
 * This component is used to render Layout items in a Dashboard Widget
 * By default, WidgetElement takes care of the rendering, but developers can override this behavior with their own Components
 *
 * You can pass different props to layout childs:
 * - HorizontalLayoutProps for HorizontalLayout
 * - VerticalLayoutProps for VerticalLayout
 * - TabProps for Tabs of TabPanelLayout
 * - TextProps for TextArea
 * - TableProps for Table
 * - ChartProps for Chart
 * - ChartContainerProps for Container of Chart (NOT containerProps of highcharts-react, this is its direct parent, used for responsiveness)
 * */
const DashboardElement = (props) => {
  const { children, data } = props
  if (children) {
    return children(data)
  }
  return <WidgetElement {...props} />
}

DashboardElement.propTypes = {
  children: PropTypes.any,
  data: PropTypes.object.isRequired,
  title: PropTypes.string,
  TableProps: PropTypes.object
}
DashboardElement.defaultProps = {
  children: undefined,
  title: undefined,
  TableProps: {}
}
export default withRecursiveLayout(DashboardElement)
